import gbIcon from '@/assets/mods/gb.webp';
import fmIcon from '@/assets/fm-whatsapp-logo.webp';
import yoIcon from '@/assets/mods/yo.webp';
import blueIcon from '@/assets/mods/blue.webp';
import ogIcon from '@/assets/mods/og.webp';
import aeroIcon from '@/assets/mods/aero.webp';

export const MODS = {
	gb: {
		id: 'gb',
		name: 'GB WhatsApp',
		icon: gbIcon,
		route: 'gb-whatsapp-apk',
		rating: '4.4',
		description: 'Advanced privacy, themes, chat locks, and messaging tools.',
		descriptionId: 'Privasi lanjutan, tema, kunci chat, dan alat perpesanan.',
	},
	fm: {
		id: 'fm',
		name: 'FM WhatsApp',
		icon: fmIcon,
		route: 'fm-whatsapp-apk',
		rating: '4.2',
		description: 'Extra privacy controls, themes, and customization options.',
		descriptionId: 'Kontrol privasi tambahan, tema khusus, dan pilihan perpesanan yang lebih fleksibel.',
	},
	yo: {
		id: 'yo',
		name: 'YOWhatsApp',
		icon: yoIcon,
		route: 'yo-whatsapp-apk',
		rating: '4.3',
		description: 'Simple interface with privacy tools and customization features.',
		descriptionId: 'Antarmuka sederhana dengan pengaturan privasi, tema, dan fitur kustomisasi.',
	},
	blue: {
		id: 'blue',
		name: 'Blue WhatsApp',
		icon: blueIcon,
		route: 'blue-whatsapp-apk',
		rating: '4.1',
		description: 'More themes, fonts, colors, and media-sharing options.',
		descriptionId: 'Lebih banyak tema, font, warna, dan pilihan berbagi media.',
	},
	og: {
		id: 'og',
		name: 'OG WhatsApp',
		icon: ogIcon,
		route: 'whatsapp-mods',
		rating: '4.2',
		description: 'Classic WhatsApp mod with privacy and customization options.',
		descriptionId: 'MOD WhatsApp klasik dengan fitur privasi dan kustomisasi tambahan.',
	},
	aero: {
		id: 'aero',
		name: 'Aero WhatsApp',
		icon: aeroIcon,
		route: 'whatsapp-mods',
		rating: '4.0',
		description: 'Visual customization and additional privacy controls.',
		descriptionId: 'Kustomisasi tampilan, berbagai tema, dan kontrol privasi tambahan.',
	},
};

export function getAlternatives(excludeId, locale = 'en') {
	return Object.values(MODS)
		.filter((mod) => mod.id !== excludeId)
		.map((mod) => ({
			...mod,
			text: locale === 'id' ? mod.descriptionId : mod.description,
		}));
}
